var _rect, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5164_14520",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#6C6C6C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5164_14520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.9963 12.4125C9.13342 12.4125 9.24955 12.3658 9.34467 12.2723C9.43992 12.1789 9.48755 12.0632 9.48755 11.925V8.58755C9.48755 8.44942 9.44117 8.33361 9.34842 8.24011C9.25567 8.14674 9.1408 8.10005 9.0038 8.10005C8.86667 8.10005 8.75055 8.14674 8.65542 8.24011C8.56017 8.33361 8.51255 8.44942 8.51255 8.58755V11.925C8.51255 12.0632 8.55892 12.1789 8.65167 12.2723C8.74442 12.3658 8.8593 12.4125 8.9963 12.4125ZM8.99611 6.96642C9.14536 6.96642 9.2718 6.91592 9.37542 6.81492C9.47905 6.71392 9.53086 6.5888 9.53086 6.43955C9.53086 6.2903 9.48036 6.16386 9.37936 6.06024C9.27836 5.95674 9.15324 5.90499 9.00399 5.90499C8.85474 5.90499 8.7283 5.95542 8.62467 6.0563C8.52105 6.1573 8.46924 6.28242 8.46924 6.43167C8.46924 6.58092 8.51974 6.70736 8.62074 6.81099C8.72174 6.91461 8.84686 6.96642 8.99611 6.96642ZM9.00642 15.825C8.06755 15.825 7.1833 15.6474 6.35367 15.2922C5.52405 14.9369 4.79792 14.4481 4.1753 13.8257C3.55267 13.2034 3.06361 12.4778 2.70811 11.649C2.35274 10.8204 2.17505 9.93499 2.17505 8.99274C2.17505 8.05049 2.35267 7.16767 2.70792 6.3443C3.06317 5.52092 3.55199 4.79792 4.17436 4.1753C4.79674 3.55267 5.5223 3.06361 6.35105 2.70811C7.17967 2.35274 8.06511 2.17505 9.00736 2.17505C9.94961 2.17505 10.8324 2.35267 11.6558 2.70792C12.4792 3.06317 13.2022 3.55199 13.8248 4.17436C14.4474 4.79674 14.9365 5.5208 15.292 6.34655C15.6474 7.17242 15.825 8.0548 15.825 8.99367C15.825 9.93255 15.6474 10.8168 15.2922 11.6464C14.9369 12.476 14.4481 13.2022 13.8257 13.8248C13.2034 14.4474 12.4793 14.9365 11.6536 15.292C10.8277 15.6474 9.9453 15.825 9.00642 15.825ZM9.00005 14.85C10.625 14.85 12.0063 14.2813 13.1438 13.1438C14.2813 12.0063 14.85 10.625 14.85 9.00005C14.85 7.37505 14.2813 5.9938 13.1438 4.8563C12.0063 3.7188 10.625 3.15005 9.00005 3.15005C7.37505 3.15005 5.9938 3.7188 4.8563 4.8563C3.7188 5.9938 3.15005 7.37505 3.15005 9.00005C3.15005 10.625 3.7188 12.0063 4.8563 13.1438C5.9938 14.2813 7.37505 14.85 9.00005 14.85Z",
    fill: "#6C6C6C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.9a2cc38aa92a1910b447b0663aa78baf.svg";
export { ForwardRef as ReactComponent };